export interface Listing {
  id: string
  images: string[]
  title: string
  category: string
  condition: string
  location: string
  rating: number
  reviewCount: number
  pricing: {
    day: number
    weekend: number
    week: number
  }
  deposit: number
  replacementValue: number
  description: string
  careInstructions: string
  owner: {
    name: string
    avatar: string
    rating: number
    totalListings: number
    reviewCount: number
    verified: boolean
  }
  reviews: Array<{
    id: string
    author: string
    rating: number
    text: string
    date: string
  }>
}

export const mockListings: Listing[] = [
  // Tools Category (5 listings)
  {
    id: 'tool-1',
    images: [
      'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=800&q=80',
      'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=800&q=80',
      'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=800&q=80',
    ],
    title: 'Professional Power Drill Set',
    category: 'Tools',
    condition: 'Used - Like New',
    location: 'Within 0.3 mi',
    rating: 4.8,
    reviewCount: 47,
    pricing: { day: 15, weekend: 40, week: 80 },
    deposit: 50,
    replacementValue: 250,
    description:
      'Complete professional drill set including multiple drill bits, carrying case, and battery charger. Perfect for home projects, drill bits are well maintained and the battery holds a great charge. Includes instruction manual and safety guide. Great for DIY projects or professional use.',
    careInstructions:
      'Please return the drill clean and in the same condition. Make sure the battery is charged before return. Store drill bits in the provided case. Do not expose to water or extreme temperatures. If any issues arise during use, please contact me immediately.',
    owner: {
      name: 'Oliver M.',
      avatar:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&q=80',
      rating: 4.9,
      totalListings: 12,
      reviewCount: 47,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'John D.',
        rating: 5,
        text: 'Great tool, exactly as described. Oliver was very helpful and flexible with pickup.',
        date: '2 weeks ago',
      },
      {
        id: '2',
        author: 'Mike R.',
        rating: 5,
        text: 'Perfect condition, made my project so much easier. Highly recommend!',
        date: '1 month ago',
      },
      {
        id: '3',
        author: 'Emma S.',
        rating: 4,
        text: 'Good drill, worked well for my needs. Owner was responsive and friendly.',
        date: '1 month ago',
      },
    ],
  },
  {
    id: 'tool-2',
    images: [
      'https://images.unsplash.com/photo-1416339442236-8ceb164046f8?w=800&q=80',
      'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80',
    ],
    title: 'Circular Saw - DeWalt',
    category: 'Tools',
    condition: 'Used - Good',
    location: 'Within 0.5 mi',
    rating: 4.9,
    reviewCount: 34,
    pricing: { day: 18, weekend: 45, week: 95 },
    deposit: 60,
    replacementValue: 280,
    description:
      'Heavy-duty circular saw perfect for cutting lumber, plywood, and other materials. Includes extra blade and carrying case. Well-maintained and regularly serviced. Powerful motor handles tough cuts with ease. Ideal for construction projects or home renovations.',
    careInstructions:
      'Always wear safety goggles when operating. Keep blade guard in place. Clean sawdust after each use. Return with blade cover attached. Do not force the saw through materials. Check blade tightness before use.',
    owner: {
      name: 'Marcus T.',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
      rating: 4.8,
      totalListings: 8,
      reviewCount: 34,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'David L.',
        rating: 5,
        text: 'Excellent saw, cut through everything I needed. Marcus was great to work with.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Sarah K.',
        rating: 5,
        text: 'Very powerful and easy to use. Perfect for my deck project.',
        date: '3 weeks ago',
      },
      {
        id: '3',
        author: 'Tom B.',
        rating: 4,
        text: 'Good tool, worked as expected. Pickup was smooth.',
        date: '1 month ago',
      },
    ],
  },
  {
    id: 'tool-3',
    images: [
      'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80',
      'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80',
    ],
    title: 'Ladder - 8ft Extension',
    category: 'Tools',
    condition: 'Used - Like New',
    location: 'Within 0.7 mi',
    rating: 4.7,
    reviewCount: 28,
    pricing: { day: 12, weekend: 30, week: 65 },
    deposit: 40,
    replacementValue: 180,
    description:
      'Sturdy aluminum extension ladder extends up to 8 feet. Perfect for painting, cleaning gutters, or accessing high areas. Lightweight yet durable construction. Non-slip feet for stability. Meets all safety standards. Easy to transport and store.',
    careInstructions:
      'Inspect ladder before each use for any damage. Keep rungs clean and dry. Do not exceed weight limit of 250 lbs. Store in dry location. Return clean and fully collapsed. Report any issues immediately.',
    owner: {
      name: 'James P.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.9,
      totalListings: 15,
      reviewCount: 62,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Rachel M.',
        rating: 5,
        text: 'Perfect for painting my house exterior. Very stable and safe.',
        date: '2 weeks ago',
      },
      {
        id: '2',
        author: 'Chris H.',
        rating: 4,
        text: 'Good ladder, easy to use. James was flexible with timing.',
        date: '3 weeks ago',
      },
      {
        id: '3',
        author: 'Linda W.',
        rating: 5,
        text: 'Exactly what I needed for gutter cleaning. Highly recommend!',
        date: '1 month ago',
      },
    ],
  },
  {
    id: 'tool-4',
    images: [
      'https://images.unsplash.com/photo-1581092918484-8313e1f7e8d6?w=800&q=80',
    ],
    title: 'Pressure Washer - Gas Powered',
    category: 'Tools',
    condition: 'Used - Good',
    location: 'Within 1.0 mi',
    rating: 4.6,
    reviewCount: 19,
    pricing: { day: 25, weekend: 60, week: 130 },
    deposit: 80,
    replacementValue: 400,
    description:
      'Powerful gas-powered pressure washer with 3000 PSI. Includes multiple nozzle attachments for different cleaning tasks. Perfect for driveways, decks, siding, and vehicles. Comes with detergent tank and 25ft hose. Well-maintained and starts easily.',
    careInstructions:
      'Fill with fresh gas before use. Run until gas tank is empty before return. Clean nozzles after use. Do not point at people or animals. Use appropriate nozzle for each surface. Store upright and secure.',
    owner: {
      name: 'Robert K.',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80',
      rating: 4.7,
      totalListings: 6,
      reviewCount: 19,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Mike S.',
        rating: 5,
        text: 'Cleaned my entire driveway in an hour. Very powerful machine!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Jennifer L.',
        rating: 4,
        text: "Works great, a bit loud but that's expected. Good value.",
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Paul R.',
        rating: 5,
        text: 'Made my deck look brand new. Robert was helpful with instructions.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'tool-5',
    images: [
      'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80',
    ],
    title: 'Tool Set - 200+ Pieces',
    category: 'Tools',
    condition: 'Used - Like New',
    location: 'Within 0.4 mi',
    rating: 4.9,
    reviewCount: 41,
    pricing: { day: 20, weekend: 50, week: 105 },
    deposit: 70,
    replacementValue: 350,
    description:
      'Comprehensive tool set with over 200 pieces including wrenches, screwdrivers, pliers, hammers, and more. Organized in rolling toolbox for easy transport. Everything you need for most home repairs and projects. All tools in excellent condition.',
    careInstructions:
      "Return all tools to their designated spots in the toolbox. Clean tools before return. Do not use tools for purposes they weren't designed for. Report any missing or damaged tools immediately. Keep toolbox closed during transport.",
    owner: {
      name: 'Daniel F.',
      avatar:
        'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80',
      rating: 5.0,
      totalListings: 9,
      reviewCount: 41,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Alex T.',
        rating: 5,
        text: 'Had every tool I needed and more. Daniel is super organized!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Maria G.',
        rating: 5,
        text: 'Perfect for my furniture assembly project. Great condition.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Kevin W.',
        rating: 5,
        text: 'Comprehensive set, saved me from buying tools. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },

  // Baby Gear Category (5 listings)
  {
    id: 'baby-1',
    images: [
      'https://images.unsplash.com/photo-1519340241574-2cec6aef0c01?w=800&q=80',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80',
    ],
    title: 'Baby Stroller - Lightweight',
    category: 'Baby Gear',
    condition: 'Used - Like New',
    location: 'Within 0.5 mi',
    rating: 4.9,
    reviewCount: 32,
    pricing: { day: 20, weekend: 50, week: 110 },
    deposit: 60,
    replacementValue: 300,
    description:
      'Lightweight and compact stroller perfect for travel or daily use. Easy one-hand fold, adjustable canopy, and large storage basket. Suitable for infants to toddlers up to 50 lbs. Smooth ride with swivel wheels. Recently cleaned and sanitized.',
    careInstructions:
      'Wipe down after use. Do not overload storage basket. Keep away from stairs when folded. Return clean and folded. Check brakes before each use. Do not leave child unattended.',
    owner: {
      name: 'Emily R.',
      avatar:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
      rating: 4.9,
      totalListings: 14,
      reviewCount: 56,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Jessica M.',
        rating: 5,
        text: 'Perfect for our vacation! So easy to fold and carry. Emily was wonderful.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Brian K.',
        rating: 5,
        text: 'Great stroller, our baby loved it. Very smooth ride.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Amy L.',
        rating: 4,
        text: 'Good quality, easy to use. Pickup was convenient.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'baby-2',
    images: [
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800&q=80',
    ],
    title: "Pack 'n Play with Bassinet",
    category: 'Baby Gear',
    condition: 'Used - Good',
    location: 'Within 0.8 mi',
    rating: 4.8,
    reviewCount: 27,
    pricing: { day: 18, weekend: 45, week: 95 },
    deposit: 50,
    replacementValue: 200,
    description:
      'Portable playard with removable bassinet attachment. Perfect for travel or visiting family. Includes carrying bag for easy transport. Mesh sides for visibility and airflow. Fits standard pack n play sheets. Clean and well-maintained.',
    careInstructions:
      'Wipe down with baby-safe cleaner before return. Ensure all parts are included. Fold according to instructions. Do not use if any parts are damaged. Keep away from heat sources. Store in provided bag.',
    owner: {
      name: 'Lisa M.',
      avatar:
        'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80',
      rating: 4.8,
      totalListings: 11,
      reviewCount: 43,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Nicole P.',
        rating: 5,
        text: 'Lifesaver for our weekend trip! Baby slept great in it.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Mark D.',
        rating: 5,
        text: 'Very clean and easy to set up. Lisa was super helpful.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Karen S.',
        rating: 4,
        text: 'Good condition, worked perfectly for our needs.',
        date: '1 month ago',
      },
    ],
  },
  {
    id: 'baby-3',
    images: [
      'https://images.unsplash.com/photo-1522771930-78848d9293e8?w=800&q=80',
    ],
    title: 'High Chair - Adjustable',
    category: 'Baby Gear',
    condition: 'Used - Like New',
    location: 'Within 0.6 mi',
    rating: 4.7,
    reviewCount: 23,
    pricing: { day: 15, weekend: 38, week: 80 },
    deposit: 45,
    replacementValue: 180,
    description:
      'Modern high chair with multiple height positions and removable tray. Easy to clean with wipeable seat pad. Grows with your child from 6 months to toddler. Stable base and 5-point harness for safety. Folds for storage.',
    careInstructions:
      'Clean tray and seat after each use. Wipe down frame. Check harness before use. Return with all parts. Do not use if straps are damaged. Ensure chair is locked in position before use.',
    owner: {
      name: 'Amanda W.',
      avatar:
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
      rating: 4.9,
      totalListings: 8,
      reviewCount: 31,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Sophia T.',
        rating: 5,
        text: 'Perfect for our visiting grandchild. Very clean and sturdy.',
        date: '2 weeks ago',
      },
      {
        id: '2',
        author: 'Ryan M.',
        rating: 4,
        text: 'Good high chair, easy to adjust. Amanda was responsive.',
        date: '3 weeks ago',
      },
      {
        id: '3',
        author: 'Michelle B.',
        rating: 5,
        text: 'Great quality, our baby was comfortable. Highly recommend!',
        date: '1 month ago',
      },
    ],
  },
  {
    id: 'baby-4',
    images: [
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800&q=80',
    ],
    title: 'Baby Carrier - Ergonomic',
    category: 'Baby Gear',
    condition: 'Used - Like New',
    location: 'Within 0.3 mi',
    rating: 5.0,
    reviewCount: 18,
    pricing: { day: 12, weekend: 30, week: 65 },
    deposit: 35,
    replacementValue: 140,
    description:
      'Comfortable ergonomic baby carrier with lumbar support. Multiple carrying positions: front, back, and hip. Suitable for newborns to toddlers (8-35 lbs). Breathable mesh panels. Adjustable straps fit all body types. Recently washed.',
    careInstructions:
      'Return clean and dry. Do not machine wash without permission. Check all buckles before use. Adjust straps for proper fit. Store in cool, dry place. Report any wear or damage immediately.',
    owner: {
      name: 'Sarah J.',
      avatar:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
      rating: 5.0,
      totalListings: 6,
      reviewCount: 18,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Laura K.',
        rating: 5,
        text: 'So comfortable! Used it for hours with no back pain. Sarah is amazing!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Tom H.',
        rating: 5,
        text: 'Perfect for hiking with our baby. Very secure and comfortable.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Emma R.',
        rating: 5,
        text: 'Great carrier, baby loved being close. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'baby-5',
    images: [
      'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800&q=80',
    ],
    title: 'Baby Monitor - Video & Audio',
    category: 'Baby Gear',
    condition: 'Used - Like New',
    location: 'Within 0.7 mi',
    rating: 4.8,
    reviewCount: 25,
    pricing: { day: 10, weekend: 25, week: 55 },
    deposit: 40,
    replacementValue: 160,
    description:
      'High-quality video baby monitor with night vision and two-way audio. 5-inch color screen with clear picture. Temperature sensor and lullabies included. Long battery life and secure connection. Perfect for peace of mind.',
    careInstructions:
      'Return with all cables and accessories. Charge fully before return. Handle screen carefully. Do not expose to water. Test before use. Keep away from other electronics that may cause interference.',
    owner: {
      name: 'Rachel C.',
      avatar:
        'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&q=80',
      rating: 4.9,
      totalListings: 7,
      reviewCount: 29,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'David M.',
        rating: 5,
        text: 'Crystal clear video, worked perfectly for our visit. Rachel was great!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Jennifer S.',
        rating: 5,
        text: 'Excellent monitor, easy to set up. Night vision is amazing.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Chris P.',
        rating: 4,
        text: 'Good quality, reliable connection. Very helpful owner.',
        date: '3 weeks ago',
      },
    ],
  },

  // Party Category (5 listings)
  {
    id: 'party-1',
    images: [
      'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=800&q=80',
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
    ],
    title: 'Folding Tables & Chairs Set',
    category: 'Party',
    condition: 'Used - Good',
    location: 'Within 1.2 mi',
    rating: 4.6,
    reviewCount: 15,
    pricing: { day: 40, weekend: 95, week: 200 },
    deposit: 80,
    replacementValue: 400,
    description:
      'Complete party set with 4 folding tables (6ft each) and 24 folding chairs. Perfect for outdoor events, parties, or gatherings. Tables have easy-clean surfaces. Chairs are comfortable with padded seats. All items in good working condition.',
    careInstructions:
      'Return clean and dry. Stack chairs carefully to avoid scratching. Fold tables properly. Do not drag furniture. Report any damage immediately. Store in dry location if keeping overnight.',
    owner: {
      name: 'Michael B.',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
      rating: 4.7,
      totalListings: 5,
      reviewCount: 22,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Patricia L.',
        rating: 5,
        text: 'Perfect for our graduation party! Michael helped with delivery.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'James R.',
        rating: 4,
        text: 'Good quality tables and chairs. Exactly what we needed.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Linda M.',
        rating: 5,
        text: 'Great for our outdoor event. Very sturdy and clean.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'party-2',
    images: [
      'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
    ],
    title: 'Pop-Up Canopy Tent - 10x10',
    category: 'Party',
    condition: 'Used - Like New',
    location: 'Within 0.9 mi',
    rating: 4.8,
    reviewCount: 21,
    pricing: { day: 30, weekend: 70, week: 145 },
    deposit: 60,
    replacementValue: 250,
    description:
      'Large pop-up canopy tent provides 100 sq ft of shade. Easy setup with no tools required. Includes carrying bag, stakes, and guy ropes. Water-resistant top. Perfect for parties, markets, or outdoor events. Adjustable height legs.',
    careInstructions:
      'Return dry and clean. Fold according to instructions. Include all stakes and ropes. Do not use in high winds. Secure properly with stakes. Store in provided bag.',
    owner: {
      name: 'Kevin S.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.8,
      totalListings: 9,
      reviewCount: 35,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Susan W.',
        rating: 5,
        text: 'Easy to set up, provided great shade. Kevin was very helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Robert T.',
        rating: 5,
        text: 'Perfect for our backyard party. Sturdy and spacious.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Mary K.',
        rating: 4,
        text: 'Good tent, worked well for our event. Easy pickup.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'party-3',
    images: [
      'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=800&q=80',
    ],
    title: 'Bluetooth Speaker System',
    category: 'Party',
    condition: 'Used - Like New',
    location: 'Within 0.5 mi',
    rating: 4.9,
    reviewCount: 38,
    pricing: { day: 25, weekend: 60, week: 125 },
    deposit: 70,
    replacementValue: 350,
    description:
      'Professional-grade portable speaker system with powerful bass. Bluetooth connectivity with 100ft range. 12-hour battery life. Includes microphone input for announcements. Perfect for parties, weddings, or outdoor events. Crystal clear sound quality.',
    careInstructions:
      'Return fully charged. Handle with care. Keep away from water. Do not exceed maximum volume for extended periods. Include all cables. Test before your event.',
    owner: {
      name: 'Carlos M.',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80',
      rating: 5.0,
      totalListings: 7,
      reviewCount: 38,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Angela P.',
        rating: 5,
        text: 'Amazing sound quality! Made our party perfect. Carlos is great!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'John M.',
        rating: 5,
        text: 'Powerful speaker, easy to use. Battery lasted all night.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Diana R.',
        rating: 5,
        text: "Best speaker we've rented. Highly recommend for events!",
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'party-4',
    images: [
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
    ],
    title: 'Outdoor String Lights - 48ft',
    category: 'Party',
    condition: 'Used - Like New',
    location: 'Within 0.6 mi',
    rating: 4.7,
    reviewCount: 19,
    pricing: { day: 15, weekend: 35, week: 75 },
    deposit: 30,
    replacementValue: 120,
    description:
      'Beautiful Edison-style string lights perfect for creating ambiance. 48 feet long with 24 bulbs. Weather-resistant for outdoor use. Warm white glow. Includes extension cord and hooks. Creates magical atmosphere for any event.',
    careInstructions:
      'Return coiled neatly. Check all bulbs before return. Do not leave outside in rain. Handle bulbs carefully. Include all hardware. Store in dry location.',
    owner: {
      name: 'Sophie L.',
      avatar:
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
      rating: 4.8,
      totalListings: 12,
      reviewCount: 47,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Michelle T.',
        rating: 5,
        text: 'Beautiful lights! Made our backyard wedding magical. Sophie was wonderful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Greg H.',
        rating: 4,
        text: 'Nice ambiance, easy to hang. Good value.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Natalie K.',
        rating: 5,
        text: 'Perfect for our party! Everyone loved the atmosphere.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'party-5',
    images: [
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80',
    ],
    title: 'Beverage Cooler - 120 Quart',
    category: 'Party',
    condition: 'Used - Good',
    location: 'Within 0.8 mi',
    rating: 4.6,
    reviewCount: 16,
    pricing: { day: 20, weekend: 45, week: 95 },
    deposit: 40,
    replacementValue: 150,
    description:
      'Extra-large cooler holds 120 quarts (holds 150+ cans). Perfect for parties, tailgating, or events. Keeps ice for days. Heavy-duty construction with wheels for easy transport. Drain plug for easy cleaning. Recently sanitized.',
    careInstructions:
      'Return clean and dry. Drain all water before return. Do not use harsh chemicals. Clean with mild soap. Ensure drain plug is secure. Store upright.',
    owner: {
      name: 'Brandon K.',
      avatar:
        'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80',
      rating: 4.7,
      totalListings: 6,
      reviewCount: 23,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Steve M.',
        rating: 5,
        text: 'Huge cooler, kept everything cold all day. Brandon was easy to work with.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Karen D.',
        rating: 4,
        text: 'Good size, worked well for our party. Wheels made it easy to move.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Paul S.',
        rating: 5,
        text: 'Perfect for our tailgate! Held tons of drinks and ice.',
        date: '3 weeks ago',
      },
    ],
  },

  // Outdoors Category (5 listings)
  {
    id: 'outdoor-1',
    images: [
      'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80',
      'https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=800&q=80',
    ],
    title: 'Camping Tent (6-person)',
    category: 'Outdoors',
    condition: 'Used - Like New',
    location: 'Within 0.8 mi',
    rating: 4.7,
    reviewCount: 28,
    pricing: { day: 35, weekend: 85, week: 175 },
    deposit: 80,
    replacementValue: 350,
    description:
      'Spacious 6-person tent with room divider for privacy. Easy setup with color-coded poles. Waterproof rainfly and sealed seams. Large mesh windows for ventilation. Includes carrying bag, stakes, and guy lines. Perfect for family camping trips.',
    careInstructions:
      'Return clean and completely dry. Shake out debris before packing. Do not pack wet. Include all poles and stakes. Check for damage before return. Store in provided bag.',
    owner: {
      name: 'Tyler W.',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
      rating: 4.8,
      totalListings: 11,
      reviewCount: 42,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Jason L.',
        rating: 5,
        text: 'Great tent! Stayed dry in the rain. Tyler gave helpful camping tips.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Amanda K.',
        rating: 4,
        text: 'Spacious and easy to set up. Perfect for our family trip.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Eric M.',
        rating: 5,
        text: 'Excellent condition, very comfortable. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'outdoor-2',
    images: [
      'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&q=80',
    ],
    title: 'Kayak - 2-Person Inflatable',
    category: 'Outdoors',
    condition: 'Used - Like New',
    location: 'Within 1.5 mi',
    rating: 4.9,
    reviewCount: 24,
    pricing: { day: 45, weekend: 110, week: 230 },
    deposit: 100,
    replacementValue: 450,
    description:
      'Durable inflatable kayak seats 2 adults comfortably. Includes 2 paddles, pump, and repair kit. Stable design perfect for beginners. Compact when deflated for easy transport. Great for lakes, rivers, and calm ocean waters. Recently inspected.',
    careInstructions:
      'Rinse with fresh water after use. Return completely dry and deflated. Check for punctures before return. Include all accessories. Do not drag on rough surfaces. Store away from direct sunlight.',
    owner: {
      name: 'Jake H.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.9,
      totalListings: 8,
      reviewCount: 31,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Nicole B.',
        rating: 5,
        text: 'So much fun! Very stable and easy to paddle. Jake was super helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Matt S.',
        rating: 5,
        text: 'Perfect for our lake trip. Easy to inflate and pack up.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Sarah P.',
        rating: 5,
        text: 'Great kayak, comfortable for two people. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'outdoor-3',
    images: [
      'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&q=80',
    ],
    title: 'Camping Stove & Cookware Set',
    category: 'Outdoors',
    condition: 'Used - Good',
    location: 'Within 0.7 mi',
    rating: 4.8,
    reviewCount: 33,
    pricing: { day: 20, weekend: 48, week: 100 },
    deposit: 50,
    replacementValue: 200,
    description:
      'Complete camping kitchen set with 2-burner propane stove, pots, pans, utensils, and plates. Stove has wind guards and adjustable flame. All cookware is lightweight and nesting for easy packing. Includes propane adapter. Perfect for camping meals.',
    careInstructions:
      'Clean all cookware before return. Return stove clean and dry. Do not include used propane. Check for food residue. Pack carefully to avoid scratches. Include all utensils and accessories.',
    owner: {
      name: 'Connor R.',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80',
      rating: 4.8,
      totalListings: 9,
      reviewCount: 38,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Rachel T.',
        rating: 5,
        text: 'Everything we needed for camp cooking! Stove worked great. Connor was awesome!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Dan M.',
        rating: 5,
        text: 'Complete set, made camping meals easy. Good quality.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Lisa K.',
        rating: 4,
        text: 'Nice cookware set, stove was reliable. Good value.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'outdoor-4',
    images: [
      'https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=800&q=80',
    ],
    title: 'Hiking Backpacks (2 Pack)',
    category: 'Outdoors',
    condition: 'Used - Like New',
    location: 'Within 0.4 mi',
    rating: 4.7,
    reviewCount: 21,
    pricing: { day: 18, weekend: 42, week: 90 },
    deposit: 45,
    replacementValue: 180,
    description:
      'Two 40L hiking backpacks with adjustable straps and hip belts. Multiple compartments and external attachment points. Hydration bladder compatible. Breathable back panel. Perfect for day hikes or overnight trips. Both in excellent condition.',
    careInstructions:
      'Return clean and dry. Empty all pockets. Do not wash in machine. Wipe down with damp cloth if needed. Check all zippers and straps. Store with straps loosened.',
    owner: {
      name: 'Megan F.',
      avatar:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
      rating: 4.9,
      totalListings: 13,
      reviewCount: 51,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Chris W.',
        rating: 5,
        text: 'Comfortable packs, perfect for our hike. Megan was very helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Julia M.',
        rating: 4,
        text: 'Good quality backpacks, fit well. Plenty of storage.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Tom R.',
        rating: 5,
        text: 'Excellent packs, carried everything we needed. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'outdoor-5',
    images: [
      'https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=800&q=80',
    ],
    title: 'Sleeping Bags (4 Pack)',
    category: 'Outdoors',
    condition: 'Used - Like New',
    location: 'Within 0.9 mi',
    rating: 4.8,
    reviewCount: 26,
    pricing: { day: 25, weekend: 60, week: 125 },
    deposit: 60,
    replacementValue: 240,
    description:
      'Four high-quality sleeping bags rated for 20°F. Soft inner lining and water-resistant outer shell. Each includes compression sack for easy packing. Full-length zipper with anti-snag design. Perfect for family camping. Recently cleaned.',
    careInstructions:
      'Return clean and dry. Air out before packing. Store in compression sacks. Do not machine wash without permission. Check for tears or damage. Keep away from sharp objects.',
    owner: {
      name: 'Alex P.',
      avatar:
        'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80',
      rating: 4.9,
      totalListings: 10,
      reviewCount: 39,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Laura S.',
        rating: 5,
        text: 'Warm and comfortable! Everyone slept great. Alex was fantastic!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Kevin D.',
        rating: 5,
        text: 'Perfect for our camping trip. Good quality bags.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Beth M.',
        rating: 4,
        text: 'Nice sleeping bags, kept us warm. Easy pickup.',
        date: '3 weeks ago',
      },
    ],
  },

  // Sports Category (5 listings)
  {
    id: 'sports-1',
    images: [
      'https://images.unsplash.com/photo-1519766304817-4f37bda74a26?w=800&q=80',
    ],
    title: 'Road Bike - 21 Speed',
    category: 'Sports',
    condition: 'Used - Good',
    location: 'Within 0.6 mi',
    rating: 4.7,
    reviewCount: 31,
    pricing: { day: 30, weekend: 70, week: 145 },
    deposit: 100,
    replacementValue: 500,
    description:
      'Lightweight aluminum road bike with 21-speed Shimano gears. Recently tuned with new tires and brake pads. Adjustable seat height. Includes helmet, lock, and pump. Perfect for fitness rides or commuting. Smooth and fast ride.',
    careInstructions:
      'Return clean and in working condition. Check tire pressure before return. Do not ride in extreme weather. Lock securely when unattended. Report any mechanical issues immediately. Return helmet clean.',
    owner: {
      name: 'Nathan G.',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
      rating: 4.8,
      totalListings: 7,
      reviewCount: 34,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Mark T.',
        rating: 5,
        text: 'Great bike, smooth ride! Nathan was super helpful with fitting.',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Emily R.',
        rating: 4,
        text: 'Good bike for the price. Gears worked perfectly.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Josh M.',
        rating: 5,
        text: 'Excellent condition, loved riding it. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'sports-2',
    images: [
      'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800&q=80',
    ],
    title: 'Paddleboard & Accessories',
    category: 'Sports',
    condition: 'Used - Like New',
    location: 'Within 1.2 mi',
    rating: 4.9,
    reviewCount: 27,
    pricing: { day: 40, weekend: 95, week: 200 },
    deposit: 120,
    replacementValue: 600,
    description:
      'Inflatable stand-up paddleboard with adjustable paddle, pump, and leash. Stable design perfect for beginners. Non-slip deck pad. Includes backpack for easy transport. Great for lakes, bays, and calm ocean. Recently inspected and cleaned.',
    careInstructions:
      'Rinse with fresh water after use. Return completely dry and deflated. Check for damage before return. Include all accessories. Do not leave inflated in hot sun. Store in provided backpack.',
    owner: {
      name: 'Jordan L.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 5.0,
      totalListings: 6,
      reviewCount: 27,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Ashley K.',
        rating: 5,
        text: 'Amazing SUP! So stable and fun. Jordan gave great tips for beginners!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Ryan P.',
        rating: 5,
        text: 'Perfect board, easy to inflate and use. Great day on the water!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Megan S.',
        rating: 5,
        text: 'Loved it! Very stable, great for learning. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'sports-3',
    images: [
      'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=800&q=80',
    ],
    title: 'Tennis Rackets & Balls Set',
    category: 'Sports',
    condition: 'Used - Like New',
    location: 'Within 0.5 mi',
    rating: 4.8,
    reviewCount: 22,
    pricing: { day: 15, weekend: 35, week: 75 },
    deposit: 40,
    replacementValue: 160,
    description:
      'Two quality tennis rackets with carrying case and fresh tennis balls. Rackets recently restrung. Comfortable grips. Perfect for recreational play. Includes 6 tennis balls. Great for getting exercise or playing with friends.',
    careInstructions:
      'Return rackets in case. Do not leave in extreme heat. Wipe down grips after use. Return all tennis balls. Check strings for damage. Store in provided case.',
    owner: {
      name: 'Victoria H.',
      avatar:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
      rating: 4.9,
      totalListings: 11,
      reviewCount: 43,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Brian M.',
        rating: 5,
        text: 'Great rackets, perfect for casual play. Victoria was wonderful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Samantha R.',
        rating: 5,
        text: 'Good quality, comfortable to use. Had a great time!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'David K.',
        rating: 4,
        text: 'Nice rackets, worked well for our game. Easy pickup.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'sports-4',
    images: [
      'https://images.unsplash.com/photo-1519315901367-f34ff9154487?w=800&q=80',
    ],
    title: 'Yoga Mats & Blocks (4 Sets)',
    category: 'Sports',
    condition: 'Used - Like New',
    location: 'Within 0.3 mi',
    rating: 5.0,
    reviewCount: 19,
    pricing: { day: 12, weekend: 28, week: 60 },
    deposit: 30,
    replacementValue: 120,
    description:
      'Four premium yoga mats with blocks and straps. Non-slip surface, extra cushioning. Each set includes 2 blocks and 1 strap. Perfect for group yoga sessions or family fitness. Recently sanitized. Comes with carrying bags.',
    careInstructions:
      'Wipe down mats after use with provided cleaner. Return rolled in carrying bags. Do not machine wash. Keep away from direct sunlight. Return all blocks and straps. Store in cool, dry place.',
    owner: {
      name: 'Olivia M.',
      avatar:
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
      rating: 5.0,
      totalListings: 8,
      reviewCount: 19,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Jessica L.',
        rating: 5,
        text: 'Perfect for our yoga retreat! Very clean and comfortable. Olivia is amazing!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Anna P.',
        rating: 5,
        text: 'Great quality mats, excellent cushioning. Highly recommend!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Michelle W.',
        rating: 5,
        text: 'Loved these mats! Perfect for our group class.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'sports-5',
    images: [
      'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800&q=80',
    ],
    title: 'Golf Club Set with Bag',
    category: 'Sports',
    condition: 'Used - Good',
    location: 'Within 0.8 mi',
    rating: 4.6,
    reviewCount: 18,
    pricing: { day: 35, weekend: 85, week: 175 },
    deposit: 90,
    replacementValue: 450,
    description:
      'Complete golf club set with driver, woods, irons, wedges, and putter. Includes golf bag with stand and rain cover. Clubs are in good condition with minimal wear. Perfect for beginners or casual golfers. Recently cleaned.',
    careInstructions:
      'Return clubs clean and dry. Wipe down grips. Return all clubs to bag. Do not leave in car trunk in heat. Check for damage before return. Store bag upright.',
    owner: {
      name: 'William D.',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80',
      rating: 4.7,
      totalListings: 5,
      reviewCount: 21,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Robert S.',
        rating: 5,
        text: 'Great set for the price! Had a wonderful round. William was helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Thomas M.',
        rating: 4,
        text: 'Good clubs, worked well for my game. Easy transaction.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'James K.',
        rating: 5,
        text: 'Perfect for trying golf without buying clubs. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },

  // Electronics Category (5 listings)
  {
    id: 'electronics-1',
    images: [
      'https://images.unsplash.com/photo-1593642532400-2682810df593?w=800&q=80',
      'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=800&q=80',
    ],
    title: 'MacBook Pro - 13 inch',
    category: 'Electronics',
    condition: 'Used - Like New',
    location: 'Within 0.4 mi',
    rating: 5.0,
    reviewCount: 12,
    pricing: { day: 50, weekend: 120, week: 250 },
    deposit: 200,
    replacementValue: 1200,
    description:
      'MacBook Pro 13" with M1 chip, 16GB RAM, 512GB SSD. Excellent condition with minimal wear. Includes charger and protective case. Perfect for work, school, or creative projects. Battery health at 95%. Recently updated to latest macOS.',
    careInstructions:
      'Return in protective case. Do not install unauthorized software. Keep away from liquids. Return fully charged. Do not remove any stickers or markings. Handle with care.',
    owner: {
      name: 'Andrew C.',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
      rating: 5.0,
      totalListings: 4,
      reviewCount: 12,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Sarah M.',
        rating: 5,
        text: 'Perfect laptop! Fast and reliable. Andrew was very professional!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Michael K.',
        rating: 5,
        text: 'Excellent condition, worked perfectly for my project. Highly recommend!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Jennifer L.',
        rating: 5,
        text: 'Great laptop, exactly as described. Very smooth rental process.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'electronics-2',
    images: [
      'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=800&q=80',
    ],
    title: 'DSLR Camera Kit - Canon',
    category: 'Electronics',
    condition: 'Used - Like New',
    location: 'Within 0.7 mi',
    rating: 4.9,
    reviewCount: 23,
    pricing: { day: 45, weekend: 110, week: 230 },
    deposit: 180,
    replacementValue: 900,
    description:
      'Canon DSLR camera with 18-55mm and 50mm lenses. Includes camera bag, extra battery, SD cards, and tripod. Perfect for events, travel, or learning photography. Recently serviced. Captures stunning photos and 4K video.',
    careInstructions:
      'Return in camera bag with all accessories. Keep lens caps on when not in use. Do not expose to extreme weather. Format SD cards before return. Handle lenses carefully. Charge batteries before return.',
    owner: {
      name: 'Ethan R.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.9,
      totalListings: 9,
      reviewCount: 37,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Amanda T.',
        rating: 5,
        text: 'Amazing camera! Captured beautiful wedding photos. Ethan was so helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Chris P.',
        rating: 5,
        text: 'Great kit, everything I needed. Photos turned out fantastic!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Lisa M.',
        rating: 4,
        text: 'Good camera, easy to use. Ethan gave great photography tips.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'electronics-3',
    images: [
      'https://images.unsplash.com/photo-1593305841991-05c297ba4575?w=800&q=80',
    ],
    title: 'iPad Pro - 12.9 inch',
    category: 'Electronics',
    condition: 'Used - Like New',
    location: 'Within 0.5 mi',
    rating: 4.8,
    reviewCount: 16,
    pricing: { day: 35, weekend: 85, week: 175 },
    deposit: 150,
    replacementValue: 800,
    description:
      'iPad Pro 12.9" with Apple Pencil and Magic Keyboard. Perfect for digital art, note-taking, or productivity. 256GB storage. Includes protective case and charger. Screen protector installed. Battery health excellent.',
    careInstructions:
      'Return in protective case. Keep screen protector on. Return Apple Pencil charged. Do not remove any apps. Handle keyboard carefully. Keep away from liquids.',
    owner: {
      name: 'Isabella S.',
      avatar:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
      rating: 4.9,
      totalListings: 7,
      reviewCount: 28,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Daniel M.',
        rating: 5,
        text: 'Perfect for my design project! Apple Pencil worked flawlessly. Isabella was great!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Rachel K.',
        rating: 5,
        text: 'Loved using this iPad! So versatile and powerful.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Kevin W.',
        rating: 4,
        text: 'Great tablet, worked perfectly for my needs. Easy rental.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'electronics-4',
    images: [
      'https://images.unsplash.com/photo-1560343090-f0409e92791a?w=800&q=80',
    ],
    title: 'Projector & Screen - 1080p',
    category: 'Electronics',
    condition: 'Used - Good',
    location: 'Within 0.9 mi',
    rating: 4.7,
    reviewCount: 21,
    pricing: { day: 40, weekend: 95, week: 200 },
    deposit: 120,
    replacementValue: 600,
    description:
      'HD projector with 100" portable screen. Bright 3000 lumens, perfect for indoor and outdoor use. Includes HDMI cables and remote. Great for movie nights, presentations, or gaming. Built-in speakers or connect external audio.',
    careInstructions:
      'Return in carrying cases. Do not move while hot. Clean lens with provided cloth only. Include all cables. Test before your event. Handle screen carefully to avoid creases.',
    owner: {
      name: 'Mason T.',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80',
      rating: 4.8,
      totalListings: 6,
      reviewCount: 24,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Nicole P.',
        rating: 5,
        text: 'Amazing for our backyard movie night! Mason helped with setup tips!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Greg H.',
        rating: 4,
        text: 'Good projector, bright picture. Worked well for our presentation.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Amy S.',
        rating: 5,
        text: 'Perfect for our party! Everyone loved the outdoor movie.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'electronics-5',
    images: [
      'https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=800&q=80',
    ],
    title: 'Gaming Console - PlayStation 5',
    category: 'Electronics',
    condition: 'Used - Like New',
    location: 'Within 0.6 mi',
    rating: 4.9,
    reviewCount: 29,
    pricing: { day: 40, weekend: 95, week: 200 },
    deposit: 160,
    replacementValue: 550,
    description:
      'PlayStation 5 with two controllers and popular games. Includes HDMI cable and all accessories. Perfect for gaming parties or trying before buying. Games include latest titles. Console in excellent condition.',
    careInstructions:
      'Return with all cables and controllers. Do not create new user accounts. Keep in well-ventilated area. Do not move while powered on. Return games in cases. Handle controllers carefully.',
    owner: {
      name: 'Lucas M.',
      avatar:
        'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80',
      rating: 5.0,
      totalListings: 5,
      reviewCount: 29,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Tyler K.',
        rating: 5,
        text: 'Epic gaming weekend! Console worked perfectly. Lucas was awesome!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Brandon S.',
        rating: 5,
        text: 'Great selection of games, console ran smoothly. Highly recommend!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Jordan P.',
        rating: 5,
        text: 'Perfect for our party! Everyone had a blast. Great rental!',
        date: '3 weeks ago',
      },
    ],
  },

  // Kitchen Category (5 listings)
  {
    id: 'kitchen-1',
    images: [
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80',
      'https://images.unsplash.com/photo-1585515320310-259814833e62?w=800&q=80',
    ],
    title: 'Stand Mixer - KitchenAid',
    category: 'Kitchen',
    condition: 'Used - Like New',
    location: 'Within 0.6 mi',
    rating: 4.8,
    reviewCount: 23,
    pricing: { day: 12, weekend: 28, week: 60 },
    deposit: 50,
    replacementValue: 350,
    description:
      'Professional KitchenAid stand mixer with multiple attachments. Includes dough hook, whisk, and paddle. Perfect for baking bread, cakes, cookies, and more. 10-speed settings. Recently serviced. Powerful motor handles heavy doughs.',
    careInstructions:
      'Clean all attachments before return. Wipe down mixer body. Do not immerse base in water. Return with all attachments. Check for dough residue. Store attachments in provided bag.',
    owner: {
      name: 'Hannah B.',
      avatar:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
      rating: 4.9,
      totalListings: 12,
      reviewCount: 48,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Patricia R.',
        rating: 5,
        text: 'Perfect for holiday baking! Made everything so easy. Hannah was wonderful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Linda M.',
        rating: 5,
        text: 'Powerful mixer, handled my bread dough perfectly. Highly recommend!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Susan K.',
        rating: 4,
        text: 'Great mixer, worked well for cakes. Easy to use.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'kitchen-2',
    images: [
      'https://images.unsplash.com/photo-1585515320310-259814833e62?w=800&q=80',
    ],
    title: 'Food Processor - Cuisinart',
    category: 'Kitchen',
    condition: 'Used - Like New',
    location: 'Within 0.4 mi',
    rating: 4.9,
    reviewCount: 18,
    pricing: { day: 10, weekend: 24, week: 50 },
    deposit: 40,
    replacementValue: 200,
    description:
      '14-cup food processor with multiple blades and discs. Chops, slices, shreds, and purees. Perfect for meal prep, sauces, and baking. Powerful motor. All parts dishwasher safe. Recently cleaned and sanitized.',
    careInstructions:
      'Clean all parts thoroughly before return. Ensure blades are dry. Return with all attachments. Handle blades carefully - very sharp. Do not overfill bowl. Store blades safely.',
    owner: {
      name: 'Grace L.',
      avatar:
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
      rating: 5.0,
      totalListings: 9,
      reviewCount: 36,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Maria S.',
        rating: 5,
        text: 'Made meal prep so fast! Worked perfectly. Grace was so helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Carol T.',
        rating: 5,
        text: 'Excellent processor, very powerful. Made salsa in seconds!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Diane W.',
        rating: 5,
        text: 'Perfect for my party prep. Saved so much time. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'kitchen-3',
    images: [
      'https://images.unsplash.com/photo-1585515320310-259814833e62?w=800&q=80',
    ],
    title: 'Espresso Machine - Breville',
    category: 'Kitchen',
    condition: 'Used - Good',
    location: 'Within 0.8 mi',
    rating: 4.7,
    reviewCount: 20,
    pricing: { day: 15, weekend: 36, week: 75 },
    deposit: 60,
    replacementValue: 400,
    description:
      'Semi-automatic espresso machine with milk frother. Makes café-quality espresso, cappuccinos, and lattes. Includes portafilter, tamper, and milk pitcher. Recently descaled. Perfect for coffee lovers or entertaining.',
    careInstructions:
      'Clean and descale before return. Empty water reservoir and drip tray. Wipe down exterior. Return all accessories. Do not use hard water. Run cleaning cycle before return.',
    owner: {
      name: 'Benjamin F.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.8,
      totalListings: 7,
      reviewCount: 27,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Steven M.',
        rating: 5,
        text: 'Amazing espresso! Benjamin gave great brewing tips. Loved it!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Richard K.',
        rating: 4,
        text: 'Good machine, made great coffee. Easy to use.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Paul R.',
        rating: 5,
        text: 'Perfect for our brunch party! Guests loved the lattes.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'kitchen-4',
    images: [
      'https://images.unsplash.com/photo-1585515320310-259814833e62?w=800&q=80',
    ],
    title: 'Instant Pot - 8 Quart',
    category: 'Kitchen',
    condition: 'Used - Like New',
    location: 'Within 0.5 mi',
    rating: 4.9,
    reviewCount: 26,
    pricing: { day: 10, weekend: 24, week: 50 },
    deposit: 45,
    replacementValue: 150,
    description:
      'Large 8-quart Instant Pot with multiple cooking functions. Pressure cook, slow cook, sauté, steam, and more. Perfect for meal prep or large gatherings. Includes extra sealing ring and recipe book. Recently cleaned.',
    careInstructions:
      'Clean inner pot and lid before return. Check sealing ring is in place. Wipe down exterior. Return with all accessories. Do not overfill. Ensure steam release valve works properly.',
    owner: {
      name: 'Sophia W.',
      avatar:
        'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&q=80',
      rating: 5.0,
      totalListings: 10,
      reviewCount: 42,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Angela M.',
        rating: 5,
        text: 'Made dinner for 12 people easily! Sophia was so helpful with recipes!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Barbara K.',
        rating: 5,
        text: 'Perfect for meal prep! Cooked everything perfectly.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Nancy R.',
        rating: 5,
        text: 'Love this Instant Pot! Made amazing stew. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'kitchen-5',
    images: [
      'https://images.unsplash.com/photo-1585515320310-259814833e62?w=800&q=80',
    ],
    title: 'Waffle Maker - Belgian Style',
    category: 'Kitchen',
    condition: 'Used - Like New',
    location: 'Within 0.3 mi',
    rating: 4.8,
    reviewCount: 15,
    pricing: { day: 8, weekend: 18, week: 40 },
    deposit: 30,
    replacementValue: 80,
    description:
      'Belgian waffle maker with adjustable browning control. Makes thick, fluffy waffles. Non-stick plates for easy cleaning. Indicator lights show when ready. Perfect for weekend brunches or special breakfasts. Recently cleaned.',
    careInstructions:
      'Clean plates after use (do not immerse in water). Wipe exterior. Return completely cool. Do not use metal utensils on plates. Check for batter residue. Store upright.',
    owner: {
      name: 'Chloe D.',
      avatar:
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
      rating: 4.9,
      totalListings: 8,
      reviewCount: 31,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Rebecca T.',
        rating: 5,
        text: 'Made perfect waffles! Kids loved them. Chloe was wonderful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Melissa P.',
        rating: 5,
        text: 'Great waffle maker, easy to use and clean. Highly recommend!',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Kimberly S.',
        rating: 4,
        text: 'Good waffle maker, worked well for our brunch. Easy rental.',
        date: '3 weeks ago',
      },
    ],
  },

  // Lawn Care Category (5 listings)
  {
    id: 'lawn-1',
    images: [
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    ],
    title: 'Lawn Mower - Self-Propelled',
    category: 'Lawn Care',
    condition: 'Used - Good',
    location: 'Within 0.7 mi',
    rating: 4.7,
    reviewCount: 24,
    pricing: { day: 30, weekend: 70, week: 145 },
    deposit: 80,
    replacementValue: 400,
    description:
      'Gas-powered self-propelled lawn mower with 21" cutting deck. Multiple height settings. Bag attachment included. Recently serviced with fresh oil and spark plug. Starts easily. Perfect for medium to large lawns.',
    careInstructions:
      'Return with empty gas tank. Clean grass clippings from deck. Check oil level. Return bag empty and clean. Do not mow wet grass. Store upright.',
    owner: {
      name: 'Ryan H.',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
      rating: 4.8,
      totalListings: 6,
      reviewCount: 28,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'George M.',
        rating: 5,
        text: 'Great mower, cut my lawn perfectly! Ryan was very helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Charles K.',
        rating: 4,
        text: 'Good mower, easy to use. Self-propel feature worked great.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Donald R.',
        rating: 5,
        text: 'Excellent condition, started right up. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'lawn-2',
    images: [
      'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&q=80',
    ],
    title: 'Leaf Blower - Gas Powered',
    category: 'Lawn Care',
    condition: 'Used - Like New',
    location: 'Within 0.5 mi',
    rating: 4.9,
    reviewCount: 19,
    pricing: { day: 20, weekend: 48, week: 100 },
    deposit: 60,
    replacementValue: 250,
    description:
      'Powerful gas leaf blower with variable speed control. Lightweight design. Perfect for clearing leaves, grass clippings, and debris. Recently serviced. Includes safety goggles. Easy to start and operate.',
    careInstructions:
      'Return with empty gas tank. Clean air filter. Wipe down exterior. Do not use in rain. Wear hearing protection. Store in upright position.',
    owner: {
      name: 'Derek P.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.9,
      totalListings: 8,
      reviewCount: 33,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Kenneth S.',
        rating: 5,
        text: 'Very powerful! Cleared my yard in no time. Derek was great!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Joseph M.',
        rating: 5,
        text: 'Excellent blower, easy to use. Made fall cleanup easy.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Timothy R.',
        rating: 5,
        text: 'Perfect for my leaves! Worked like a charm. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'lawn-3',
    images: [
      'https://images.unsplash.com/photo-1617576683096-00fc8eecb3af?w=800&q=80',
    ],
    title: 'Hedge Trimmer - Electric',
    category: 'Lawn Care',
    condition: 'Used - Like New',
    location: 'Within 0.6 mi',
    rating: 4.8,
    reviewCount: 17,
    pricing: { day: 18, weekend: 42, week: 90 },
    deposit: 50,
    replacementValue: 180,
    description:
      'Electric hedge trimmer with 24" dual-action blade. Lightweight and easy to maneuver. Includes extension cord. Perfect for shaping hedges and bushes. Sharp blades recently serviced. Safety guard included.',
    careInstructions:
      'Clean blades before return. Return with cord wrapped neatly. Do not use in wet conditions. Wear safety goggles. Check blade guard. Store in safe location.',
    owner: {
      name: 'Aaron T.',
      avatar:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80',
      rating: 4.8,
      totalListings: 7,
      reviewCount: 25,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Edward L.',
        rating: 5,
        text: 'Made my hedges look professional! Aaron gave great trimming tips!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Raymond K.',
        rating: 5,
        text: 'Sharp blades, easy to control. Perfect for my bushes.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Gregory M.',
        rating: 4,
        text: 'Good trimmer, worked well. Easy to use.',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'lawn-4',
    images: [
      'https://images.unsplash.com/photo-1617576683096-00fc8eecb3af?w=800&q=80',
    ],
    title: 'Garden Tiller - Gas Powered',
    category: 'Lawn Care',
    condition: 'Used - Good',
    location: 'Within 0.9 mi',
    rating: 4.6,
    reviewCount: 14,
    pricing: { day: 35, weekend: 85, week: 175 },
    deposit: 90,
    replacementValue: 450,
    description:
      'Heavy-duty gas tiller for breaking ground and mixing soil. Adjustable tilling width and depth. Perfect for garden beds and landscaping projects. Recently serviced. Powerful engine handles tough soil.',
    careInstructions:
      'Return with empty gas tank. Clean tines thoroughly. Check oil level. Do not till rocky soil. Wear sturdy boots. Store upright and secure.',
    owner: {
      name: 'Patrick M.',
      avatar:
        'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80',
      rating: 4.7,
      totalListings: 5,
      reviewCount: 18,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Frank R.',
        rating: 5,
        text: 'Powerful tiller! Broke up my hard soil easily. Patrick was helpful!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Larry S.',
        rating: 4,
        text: 'Good tiller, worked well for my garden. Easy to operate.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Scott K.',
        rating: 5,
        text: 'Perfect for my landscaping project. Very effective!',
        date: '3 weeks ago',
      },
    ],
  },
  {
    id: 'lawn-5',
    images: [
      'https://images.unsplash.com/photo-1617576683096-00fc8eecb3af?w=800&q=80',
    ],
    title: 'Chainsaw - 16 inch Bar',
    category: 'Lawn Care',
    condition: 'Used - Good',
    location: 'Within 0.8 mi',
    rating: 4.7,
    reviewCount: 16,
    pricing: { day: 25, weekend: 60, week: 125 },
    deposit: 70,
    replacementValue: 300,
    description:
      'Gas-powered chainsaw with 16" bar. Perfect for cutting firewood, trimming trees, and storm cleanup. Recently sharpened chain. Includes safety chaps and goggles. Easy to start. Powerful and reliable.',
    careInstructions:
      'Return with empty gas tank. Clean sawdust from body. Check chain tension. Return safety gear. Do not use if inexperienced. Store chain covered.',
    owner: {
      name: 'Trevor L.',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
      rating: 4.8,
      totalListings: 6,
      reviewCount: 22,
      verified: true,
    },
    reviews: [
      {
        id: '1',
        author: 'Gary W.',
        rating: 5,
        text: 'Sharp chain, cut through logs easily! Trevor gave safety instructions!',
        date: '1 week ago',
      },
      {
        id: '2',
        author: 'Dennis M.',
        rating: 4,
        text: 'Good chainsaw, worked well for my firewood. Powerful.',
        date: '2 weeks ago',
      },
      {
        id: '3',
        author: 'Jerry K.',
        rating: 5,
        text: 'Perfect for storm cleanup! Very reliable. Highly recommend!',
        date: '3 weeks ago',
      },
    ],
  },
]

export function getListingById(id: string): Listing | undefined {
  return mockListings.find((listing) => listing.id === id)
}

export function getListingsByCategory(category: string): Listing[] {
  return mockListings.filter((listing) => listing.category === category)
}

export function getAllListings(): Listing[] {
  return mockListings
}
